import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import Panel from '../Panel';
import Errorable from '../lib/Errorable/';
import Loadable from '../lib/Loadable/';
import { Field, reduxForm } from 'redux-form';
import BootstrapField from '../lib/bootstrapfield/';
import isEmail from 'sane-email-validation';

@reduxForm({ form: 'request' })
@Errorable({ errorProp: 'requestError' })
@Loadable({ size: 'medium' })
class RequestForm extends Component {
  static propTypes = {
    fullscreen: PropTypes.bool,
    hide: PropTypes.bool,
    appHeight: PropTypes.number,
    appWidth: PropTypes.number,
    userTimezoneOffset: PropTypes.number,
    notVisible: PropTypes.bool,
    onStartChat: PropTypes.func.isRequired
  };

  render() {
    return (
      <Panel
        fullscreen={this.props.fullscreen}
        hide={this.props.fullscreen}
        notVisible={this.props.notVisible} padding={20}
        appHeight={this.props.appHeight}
        appWidth={this.props.appWidth}
        className="tpchat-form"
      >
        {this.loading()}
        <form onSubmit={this.props.handleSubmit(this.props.onStartChat.bind(null, this.props.userTimezoneOffset))}>
          <Field
            name="name"
            component={BootstrapField}
            type="text"
            autoFocus={this.props.pristine}
            label="Nombre y Apellido"
            validate={v => v ? undefined : 'El nombre es requerido'}
          />
          <Field
            name="email"
            component={BootstrapField}
            type="email"
            autoFocus={this.props.pristine}
            label="Email"
            validate={v => v ? undefined : 'El email es requerido'}
          />
          {this.error()}
          <div className="text-center">
            <B.Button bsStyle="primary" type="submit">
              Iniciar Chat
            </B.Button>
          </div>
        </form>
      </Panel>
    );
  }
}

export default RequestForm;



// WEBPACK FOOTER //
// ./components/requestForm/index.js